import { Typography } from '@material-ui/core';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import { TypographyProps } from '@material-ui/core/Typography';
import classnames from 'classnames';
import * as React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'uppercase',
      borderBottom: `1px solid ${theme.palette.text.primary}57`,
      display: 'flex'
    }
  });

type ISubHeadingProps = TypographyProps & WithStyles<typeof styles>;

function SubHeading(props: ISubHeadingProps) {
  const { classes, className } = props;
  const rootClasses = classnames(classes.root, className);
  return (
    <Typography className={rootClasses} variant="subtitle1">
      {props.children}
    </Typography>
  );
}

export default withStyles(styles)(SubHeading);
